// versioni.js — «ka version të ri» brenda aplikacionit (VERSIONI1, 3 nëntor 2026).
//
// Logjika e pastër rri këtu; komponenti (VersioniIRi.jsx) vetëm e vizaton.
// Politika vjen nga serveri (`rpc_get_app_version_policy`) dhe e vendos Admin
// Center-i: «i fundit» = versioni që është vërtet në dyqan, «minimal» = më i
// vjetri që lejohet. Çdo dështim lexohet si «s'ka politikë» — një kontroll
// versioni nuk guxon kurrë ta bllokojë njeriun për shkak të rrjetit.

import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import { supabase } from "./supabaseClient";

export const PAKETA = "com.pemaefamiljes.app";

export function eshteNative() {
  try { return Capacitor.isNativePlatform(); } catch (_e) { return false; }
}

export function platformaNative() {
  try { return Capacitor.getPlatform(); } catch (_e) { return "web"; }
}

// Versioni që njeriu ka INSTALUAR (jo ai i kodit web): `versionName` te Android,
// `CFBundleShortVersionString` te iOS. Te shfletuesi s'ka të tillë → null.
let _instaluar = null;
export function versioniIInstaluar() {
  if (!eshteNative()) return Promise.resolve(null);
  if (!_instaluar) {
    _instaluar = Promise.resolve(CapacitorApp.getInfo())
      .then((i) => (i && typeof i.version === "string" && i.version.trim()) || null)
      .catch(() => null);
  }
  return _instaluar;
}

const VLEFSHEM = /^[0-9]+(\.[0-9]+){0,3}$/;

// -1 / 0 / 1, ose null nëse njëri s'është version i vlefshëm. «1.2.10» > «1.2.9».
export function krahasoVersionet(a, b) {
  if (typeof a !== "string" || typeof b !== "string") return null;
  a = a.trim(); b = b.trim();
  if (!VLEFSHEM.test(a) || !VLEFSHEM.test(b)) return null;
  const x = a.split(".").map(Number);
  const y = b.split(".").map(Number);
  for (let i = 0; i < 4; i++) {
    const p = x[i] || 0;
    const q = y[i] || 0;
    if (p < q) return -1;
    if (p > q) return 1;
  }
  return 0;
}

// Kur admini s'ka vendosur lidhje: Android hap faqen e paketës te Play;
// iOS ka nevojë për ID-në e aplikacionit, prandaj bie te kërkimi.
export function lidhjaEDyqanit(platforma, url) {
  if (typeof url === "string" && /^https:\/\/\S+$/i.test(url)) return url;
  if (platforma === "android") return `https://play.google.com/store/apps/details?id=${PAKETA}`;
  return `https://apps.apple.com/search?term=${encodeURIComponent("Pema e Familjes")}`;
}

// Çfarë duhet bërë për këtë instalim: { niveli: "bllok" | "buta", ... } ose null.
export function vleresoPolitiken(politika, instaluar, platforma) {
  if (!politika || typeof politika !== "object" || !instaluar) return null;
  const rreshti = politika[platforma];
  if (!rreshti || typeof rreshti !== "object") return null;
  const url = lidhjaEDyqanit(platforma, rreshti.url);
  const mesazhi = typeof rreshti.message === "string" && rreshti.message.trim() ? rreshti.message.trim() : null;
  if (rreshti.min && krahasoVersionet(instaluar, rreshti.min) === -1) {
    return { niveli: "bllok", eFundit: rreshti.latest || rreshti.min, mesazhi, url };
  }
  if (rreshti.latest && krahasoVersionet(instaluar, rreshti.latest) === -1) {
    return { niveli: "buta", eFundit: rreshti.latest, mesazhi, url };
  }
  return null;
}

export async function merrPolitiken() {
  try {
    const { data, error } = await supabase.rpc("rpc_get_app_version_policy");
    if (error || !data || typeof data !== "object") return null;
    return data;
  } catch (_e) {
    return null;
  }
}

// «Më vonë» vlen 3 ditë, dhe vetëm për atë version të fundit — kur del një i ri,
// njeriu e sheh sërish.
const VONE_KEY = "pef_versioni_vone";
export const VONE_MS = 3 * 24 * 60 * 60 * 1000;

export function eShtyre(eFundit) {
  try {
    const r = JSON.parse(localStorage.getItem(VONE_KEY) || "null");
    return !!(r && r.v === eFundit && Date.now() - Number(r.at) < VONE_MS);
  } catch (_e) { return false; }
}

export function shtyje(eFundit) {
  try { localStorage.setItem(VONE_KEY, JSON.stringify({ v: eFundit, at: Date.now() })); } catch (_e) { /* modalitet privat */ }
}

// Shtypja e mesazhit «ka version të ri» te shiriti i sipërm (VERSIONI5): hap
// dyqanin e platformës. Lidhja e adminit ka përparësi; pa të, Play sipas paketës.
// Id-ja e rreshtit të përkohshëm që krijon `rpc_list_header_messages` (VERSIONI2/4).
export const ID_MESAZHI_PERDITESIM = "00000000-0000-0000-0000-00000000a9d1";

export async function hapDyqaninNgaShiriti() {
  const platforma = platformaNative();
  if (!eshteNative()) { try { window.location.reload(); } catch (_e) { /* asgjë */ } return; }
  const politika = await merrPolitiken();
  const rreshti = politika && typeof politika === "object" ? politika[platforma] : null;
  const url = lidhjaEDyqanit(platforma, rreshti && rreshti.url);
  try { window.location.href = url; } catch (_e) { /* asgjë */ }
}
